import { render, staticRenderFns } from "./OptionPanel.vue?vue&type=template&id=8060ecba&scoped=true&"
import script from "./OptionPanel.vue?vue&type=script&lang=ts&"
export * from "./OptionPanel.vue?vue&type=script&lang=ts&"
import style0 from "./OptionPanel.vue?vue&type=style&index=0&id=8060ecba&scoped=true&lang=scss&"
import style1 from "./OptionPanel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8060ecba",
  null
  
)

export default component.exports